export const resolveNotExists = () => {
    return {
        output_type: 'boolean',
        type: 'not-exists-condition',
    };
};
//# sourceMappingURL=not-exists.js.map